"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var react_styles_1 = require("@patternfly/react-styles");

var divider_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Divider/divider"));

var util_1 = require("../../helpers/util");

var DividerVariant;

(function (DividerVariant) {
  DividerVariant["hr"] = "hr";
  DividerVariant["li"] = "li";
  DividerVariant["div"] = "div";
})(DividerVariant = exports.DividerVariant || (exports.DividerVariant = {}));

exports.Divider = function (_a) {
  var className = _a.className,
      _a$component = _a.component,
      component = _a$component === void 0 ? DividerVariant.hr : _a$component,
      _a$isVertical = _a.isVertical,
      isVertical = _a$isVertical === void 0 ? false : _a$isVertical,
      inset = _a.inset,
      props = tslib_1.__rest(_a, ["className", "component", "isVertical", "inset"]);

  var Component = component;
  return React.createElement(Component, Object.assign({
    className: react_styles_1.css(divider_1["default"].divider, isVertical && divider_1["default"].modifiers.vertical, util_1.formatBreakpointMods(inset, divider_1["default"]), className)
  }, component !== 'hr' && {
    role: 'separator'
  }, props));
};

exports.Divider.displayName = 'Divider';